import { useEffect } from 'react';

import storage, { EStorageKey } from '../storage';
import { checkIsNative } from '../validators';

export const useMarketingPageUrl = () => {
  useEffect(() => {
    if (!checkIsNative() && window.location.search) {
      storage.setItem(EStorageKey.MARKETING_PARAMS, window.location.search);
    }
  }, []);
};
